import React from "react";
import EditDetail from "../SmcLife/Images/editdetail.svg";
import "../SmcLife/IndexLife.css";
import Male from "../SmcLife/Images/male-icon2.svg";
import Female from "../SmcLife/Images/female-icon2.svg";
import { useState } from "react";
import { useEffect } from "react";
import EditDetailCard from "./EditDetailCard";
import { FilterData } from "./UtilityComponents/FilterData";
import { BiSolidChevronDown } from "react-icons/bi";
import { calculateAge, CalculateUserAge, PayDuration } from "./UtilityComponents/UtilityFunction"
import LifeAddons from "./LifeAddons";
import PayForPopup from "./PayForPopup";


const SumInsured = [
    { value: "1000000", label: "₹10 Lakhs" },
    { value: "1500000", label: "₹15 Lakhs" },
    { value: "2000000", label: "₹20 Lakhs" },
    { value: "2500000", label: "₹25 Lakhs" },
    { value: "3000000", label: "₹30 Lakhs" },
    { value: "3500000", label: "₹35 Lakhs" },
    { value: "4000000", label: "₹40 Lakhs" },
    { value: "4500000", label: "₹45 Lakhs" },
    { value: "5000000", label: "₹50 Lakhs" },
    { value: "6000000", label: "₹60 Lakhs" },
    { value: "7000000", label: "₹70 Lakhs" },
    { value: "8000000", label: "₹80 Lakhs" },
    { value: "9000000", label: "₹90 Lakhs" },
    { value: "10000000", label: "₹1 Crore" },
    { value: "20000000", label: "₹2 Crore" },
    { value: "30000000", label: "₹3 Crore" },
    { value: "40000000", label: "₹4 Crore" },
    { value: "50000000", label: "₹5 Crore" },
    { value: "60000000", label: "₹6 Crore" },
    { value: "70000000", label: "₹7 Crore" },
    { value: "80000000", label: "₹8 Crore" },
    { value: "90000000", label: "₹9 Crore" },
    { value: "100000000", label: "₹10 Crore" },
    { value: "110000000", label: "₹11 Crore" },
    { value: "120000000", label: "₹12 Crore" },
    { value: "130000000", label: "₹13 Crore" },
    { value: "140000000", label: "₹14 Crore" },
    { value: "150000000", label: "₹15 Crore" },
    { value: "160000000", label: "₹16 Crore" },
    { value: "170000000", label: "₹17 Crore" },
    { value: "180000000", label: "₹18 Crore" },
    { value: "190000000", label: "₹19 Crore" },
    { value: "200000000", label: "₹20 Crore" },
    { value: "210000000", label: "₹21 Crore" },
    { value: "220000000", label: "₹22 Crore" },
    { value: "230000000", label: "₹23 Crore" },
    { value: "240000000", label: "₹24 Crore" },
    { value: "250000000", label: "₹25 Crore" },
    { value: "260000000", label: "₹26 Crore" },
    { value: "270000000", label: "₹27 Crore" },
    { value: "280000000", label: "₹28 Crore" },
    { value: "290000000", label: "₹29 Crore" },
    { value: "300000000", label: "₹30 Crore" },

]

const PremiumFrequency = [
    { value: "Y", label: "Yearly" },
    { value: "H", label: "Half-Yearly" },
    { value: "M", label: "Monthly" },
    { value: "Q", label: "Quarterly" },
    { value: "S", label: "One Time" },
]

const LifeQuoteDetail = (props) => {
    const [IsPlanshow, setIsPlanshow] = useState(false);
    const [options, setOptions] = useState([]);
    const [tillAgeBox, setTillAgeBox] = useState("");
    const [tillPayYear, setTillPayYear] = useState("");
    const [premiumFreq, setPremiumFreq] = useState('Y');
    const [InsurerAge, setInsurerAge] = useState("");
    const [IsLifeAddons, setIsLifeAddons] = useState(false);
    const [BenefitRiderTab, setBenefitRiderTab] = useState("Benefits")
    const [countBenefit, setCountBenefit] = useState(0);
    const [countRiders, setCountRiders] = useState(0);
    const [IsPayFor, setPayFor] = useState(false);
    const [PeymentTermTillAge, setPeymentTermTillAge] = useState("")

    const IsPlandetail = () => {
        setIsPlanshow(!IsPlanshow);
    };

    const IsOpenBenfit = (params) => {
        if (params === 'Benefits') {
            setIsLifeAddons(!IsLifeAddons);
            setBenefitRiderTab("Benefits");
        }
        else {

            setIsLifeAddons(!IsLifeAddons);
            setBenefitRiderTab("Riders");
        }
    }
    const Isclosepop = () => {
        setIsLifeAddons(!IsLifeAddons);
    }
    const handleBenefitCount = (data) => {

        setCountBenefit(data);
    }
    //const Critical = sessionStorage.setItem("props.IsCriticalIllness", false);

    useEffect(() => {

        const storedBenefits = sessionStorage.getItem("benefitCount");
        const storedRiders = sessionStorage.getItem("riderCount");

        storedBenefits ? setCountBenefit(parseInt(storedBenefits)) : setCountBenefit(0);
        storedRiders ? setCountRiders(parseInt(storedRiders)) : setCountRiders(0);
    }, [countBenefit, countRiders])

    useEffect(() => {
        setPremiumFreq(props.Data.PremiumFrequency);
    }, []);

    const handleRiderCount = (data) => {
        setCountRiders(data);
    }

    const getAge = (dob) => {
        let today = new Date();
        let birthDate = new Date(dob);
        let age = today.getFullYear() - birthDate.getFullYear();
        let month = today.getMonth() - birthDate.getMonth();
        if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    useEffect(() => {

        const tillAge = new Date().getFullYear() + (props?.Data?.CoverTillAge - (new Date().getFullYear() - new Date(props?.Data?.DoB).getFullYear()))
        setTillAgeBox(tillAge)

        let age = getAge(props.Data.DoB)
        setInsurerAge(age)

        if (props.Data.DoB) {
            setOptions(calculateAge(age));
        }

      //  console.log("props", props.Data);
        const tillYear = new Date().getFullYear() + parseInt(props?.Data?.PayTerm)
        setTillPayYear(tillYear)


    }, [props]);

    const handlePremiumFrequencyChange = (event) => {
        const premiumValue = event.target.value;
        setPremiumFreq(premiumValue);
        if (premiumValue === "S") {
            props.getQuoteOnchange("PayFor", 1, "call");
        }
        props.getQuoteOnchange("Payfrequency", premiumValue);
    };

    /*let PeymentTerm = props?.Data.CoverTillAge - age;
    setPeymentTermTillAge(parseInt(PeymentTerm));

    console.log(PeymentTerm, "dddd");*/

    const updateValues = (value) => {
        setPremiumFreq(value);
        props.getQuoteOnchange("Payfrequency", value, "call");
    }

    


    return (
        <>
            <div className="life_quote_detail">
                <div className="life_shdow">
                    <div className="DetailBorderRight">
                        <div className="SmcCustomerpolicy">
                            <div className="">
                                {/*<span className="QuoteL2">Your Details</span>*/}
                                <div className="mb-0 user_detail">
                                    {props?.Data?.Gender === "M" ? (
                                        <img src={Male} className="Cust_Detail_Abt" />
                                    ) : (
                                        <img src={Female} className="Cust_Detail_Abt" />
                                    )}
                                    <div className="user_detail2">
                                        {InsurerAge} years,{" "}
                                        {props?.Data?.Gender === "M" ? "Male" : "Female"},{" "}
                                        {props?.Data?.IsSmoker === false
                                            ? "Non-smoker"
                                            : "Smoker"}
                                    </div>
                                </div>
                            </div>
                            <div className="" onClick={() => IsPlandetail()}>
                                <span className="LifeEditCust LifeEditTablet">
                                    <img src={EditDetail} alt="editdetail" />
                                    <span>Edit</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="quotes_options">
                    <div className="user-input-wrp respo_term">
                        <div className="quotes_opt">
                            <span className="DropDown_label">Coverage Amount</span>
                            <FilterData
                                ArrayList={SumInsured}
                                FilterKey={"value"}
                                //onSelect={(SumInsured) => { props.getQuoteOnchange((prev) => ({ ...prev, SumInsured: props?.Data?.value })); }}
                                onSelect={(SumInsured) => { props.getQuoteOnchange("Cover", SumInsured.value); }}
                                DefaultTitle={props.Data.SumInsured === " " ? "Coverage Amount" : SumInsured?.filter(row => row.value == props.Data.SumInsured)[0]?.label}
                                ListNameKey={"label"}
                                className="filter_dropdwon"
                                id="Cover"
                            />
                        </div>


                    </div>
                    <div className="user-input-wrp Quote_Vacant2_Box respo_term">
                        <div className="quotes_opt">
                            <span className="DropDown_label">Cover till Age</span>
                            <div className="shade-life">till {tillAgeBox}</div>
                            <FilterData
                                ArrayList={options}
                                FilterKey={"value"}
                                onSelect={(data) => { props.getQuoteOnchange("Coverage", data.value); }}
                                DefaultTitle={props.Data.CoverTillAge ? options?.find(row => row.value == props.Data.CoverTillAge)?.label : "Cover till Age"}
                                ListNameKey={"label"}

                            />
                            <span className="errors-msg">{Error["coverAge"]}</span>
                        </div>

                    </div>


                    {/* PREMIUM FREQUENCY */}
                    <div className="user-input-wrp Quote_Vacant2_Box respo_term">
                        <div className="quotes_opt">
                            <span className="DropDown_label">Payment Frequency</span>
                            <select value={premiumFreq} onChange={handlePremiumFrequencyChange} className="filter_dropdwon">
                                {PremiumFrequency.map((freq) => (
                                    <option key={freq.value} value={freq.value}>
                                        {freq.label}
                                    </option>
                                ))}
                            </select>

                            {/*<FilterData
                                ArrayList={PremiumFrequency}
                                FilterKey={"value"}
                                onSelect={(PremiumFrequency) => {
                                    if (PremiumFrequency.value === "S")
                                        props.getQuoteOnchange("PayFor", 1, "call");
                                    props.getQuoteOnchange("Payfrequency", PremiumFrequency.value);
                                }}
                                //DefaultTitle={props?.Data?.PremiumFrequency ? PremiumFrequency.find(row => row.value == props?.Data?.PremiumFrequency)?.label : "Pay For"}
                                DefaultTitle={props.Data.PremiumFrequency === " " ? "Payment Frequency" : PremiumFrequency?.filter(row => row.value == props.Data.PremiumFrequency)[0]?.label}
                                ListNameKey={"label"}

                            />*/}
                        </div>

                    </div>

                    {props.Data.PremiumFrequency !== "S" && <div className="user-input-wrp t-input Quote_Vacant2_Box Quote_Vacant2_Box2 respo_term">
                        <div className="quotes_opt" onClick={() => setPayFor(true)}>
                            <span className="DropDown_label">Pay For</span>

                            <div className="shade-life">till {tillPayYear}</div>
                            <FilterData
                                ArrayList={[]}
                                FilterKey={"value"}
                                onSelect={(data) => { props.getQuoteOnchange("PayFor", data.value); setPayFor(false); }}
                                DefaultTitle={`${props.Data.PayTerm}  ${props.Data.PayTerm == 1 ? "Year":"Years"}`}
                                ListNameKey={"label"}

                            />

                        </div>

                    </div>}
                </div>
                <div className="life_mobile_benefit_rider">
                    <div className="life_edit_container">
                        <div className="DetailBorderRight">
                            <div className="SmcCustomerpolicy">
                                <div className="">
                                    {/*<span className="QuoteL2">Your Details</span>*/}
                                    <div className="mb-0 user_detail">
                                        {props?.Data?.Gender === "M" ? (
                                            <img src={Male} className="Cust_Detail_Abt" />
                                        ) : (
                                            <img src={Female} className="Cust_Detail_Abt" />
                                        )}
                                        <div className="user_detail2">
                                            {InsurerAge} years,{" "}
                                            {props?.Data?.Gender === "M" ? "Male" : "Female"},{" "}
                                            {props?.Data?.IsSmoker === false
                                                ? "Non-smoker"
                                                : "Smoker"}
                                        </div>
                                    </div>
                                </div>
                                <div className="" onClick={() => IsPlandetail()}>
                                    <span className="LifeEditCust">
                                        <img src={EditDetail} alt="editdetail" />
                                        <span>Edit</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="blank_container blank_container2"></div>
                    <div className="blank_div blank_div2"></div>

                    <div className="quotes_options Benefits-Riders" >
                        <div className="user-input-wrp respo_term" onClick={() => IsOpenBenfit('Benefits')}>
                            <div className="quotes_opt">
                                <span className="DropDown_label">Benefits</span>
                                <div className="Benefits" >
                                    <p className="BenefitsSelector">
                                        {countBenefit ? <span className="BenefitText benefits_and_riders_color">{countBenefit > 1 ? `${countBenefit} Benefits Added` : `${countBenefit} Benefit Added`}
                                        </span> : <span className="BenefitText">Select Benefits</span>}

                                        <span className="DownArrow"><BiSolidChevronDown /></span>
                                    </p>
                                </div>
                            </div>
                        </div>


                        <div className="user-input-wrp respo_term" onClick={() => IsOpenBenfit('Riders')}>
                            <div className="quotes_opt">
                                <span className="DropDown_label">Riders</span>
                                <div className="Benefits Riders" >
                                    <p className="BenefitsSelector RidersSelector">
                                        {countRiders ? <span className="BenefitText RiderText benefits_and_riders_color" >{countRiders > 1 ? `${countRiders} Riders Added` : `${countRiders} Rider Added`}
                                        </span> : <span className="BenefitText RiderText" >Select Riders</span>}
                                        <span className="DownArrow"><BiSolidChevronDown /></span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {IsLifeAddons && (
                <LifeAddons Tab={BenefitRiderTab} CallQuoteWithRiderAddons={props.CallQuoteWithRiderAddons} CoverageAmount={props.Data.SumInsured} IsClose={() => Isclosepop()} Data={props.Data} CountRiders={handleRiderCount} CountBenefit={handleBenefitCount} />
            )}
            {IsPayFor && (
                <PayForPopup
                    Data={props.Data}
                    Close={() => setPayFor(false)}
                    PeymentTermTillAge={PeymentTermTillAge}
                    OnSubmit={(data) => props.getQuoteOnchange("PayFor", data)}
                    UpdateValues={updateValues}
                />
            )}
            {IsPlanshow && (
                <div className="EditDetailShadow">
                    <EditDetailCard
                        UpdateCoverTillAgeOnDOB={props.UpdateCoverTillAgeOnDOB}
                        UpdateResult={props.UpdateResult}
                        Data={props.Data}
                        isHousewife={props.isHousewife}
                        editDetailType={props.IsFromWomenComponent ? "womenLife" : "lifeIns"}
                        OccupationList={props.OccupationList ?? []}
                        EducationList={props.EducationList ?? []}
                        occupationOptions={props.occupationOptions}
                        allTermLifePath={props.allTermLifePath}
                    />
                </div>
            )}
        </>
    );
};
export default LifeQuoteDetail;


